import { get} from "./httpBridge";

// Бридж для получения товаров с маркетплейсов
export default function Bridge() {
    return {
      // получение товаров с WB
      getWB: async (uid) => get('WBAPI/getCards', {uid}),
      getWBCardAndStocks: async (uid) => get('WBAPI/getCardAndStocks', {uid}),
      GetWBCardWithStocksAndStorage: async (uid) => get('WBAPI/GetCardWithStocksAndStorage', {uid}),
      getOZON: async (uid) => get('OZONAPI/getCards', {uid}),
      getOZONCardAndStocks: async (uid) => get('OZONAPI/getCardAndStocks', {uid}),
      GetOZONCardWithStocksAndStorage: async (uid) => get('OZONAPI/GetCardWithStocksAndStorage', {uid})
    };
  }